import i18n from 'i18n';

export const iconAccessibleText = {
  error: i18n.t('labels.errorMsg'),
  warning: i18n.t('labels.warningMsg'),
  success: i18n.t('labels.successMsg'),
  info: i18n.t('labels.infoMsg')
};
